import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { OrganizationEmployee } from '@/modules/Users/domain';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

type UseGetUsersByOrganizationProps = {
  organizationId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
  options?: UseQueryOptions<
    DataWithPagination<OrganizationEmployee[]>,
    any,
    DataWithPagination<OrganizationEmployee[]>
  >;
};

export const useGetEmployeesByOrganization = ({
  organizationId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
  options,
}: UseGetUsersByOrganizationProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<DataWithPagination<OrganizationEmployee[]>>(
    [
      ...UserKey.BY_ORGANIZATION_PAGED(organizationId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      usersRepo.getEmployeesByOrganization(
        organizationId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    { ...options, cacheTime: 1000 * 60 * 5 },
  );
};
